// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__hWNQx","error":"Textarea_error__3wYHJ","readonly":"Textarea_readonly__2z-Jm","disabled":"Textarea_disabled__1UOjg"};